import React, { useState } from 'react'
import { SURGE_CARGA_IMAGENES_BUSQUEDA } from '../../../../utils/constants';
import { ItemsAltaCosto } from './table/altoCosto/ItemsAltaCosto';
import { ItemsMateriales } from './table/materiales/ItemsMateriales';
import { ItemsSolPagoOP } from './table/solPagoConOP/ItemsSolPagoOP';
import { ItemsSolPago } from './table/solPago/ItemsSolPago';
import { ItemsSolicitudes } from './table/solicitudes/ItemsSolicitudes';
import { Modalnformacion } from './modal/Modalnformacion';
import { ItemsHiv } from './table/hiv/ItemsHiv';

export const GestionImagenesItem = (props) => {

  const { item, estadosImagenes } = props;

  const [openModalInfo, setOpenModalInfo] = useState(false);

  console.log(openModalInfo)

  return (
    <>
      {openModalInfo && (
        <Modalnformacion
          open={openModalInfo}
          closeModalHandler={() => {
            setOpenModalInfo(false);
          }}
          item={item}
        />
      )}
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.ALTO_COSTO) &&
        <ItemsAltaCosto item={item} />
      }
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.MATERIALES) &&
        <ItemsMateriales item={item} openModalInfo={openModalInfo} setOpenModalInfo={setOpenModalInfo} />
      }
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOLICITUDES) &&
        <ItemsSolicitudes item={item} openModalInfo={openModalInfo} setOpenModalInfo={setOpenModalInfo} />
      }
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_LIQUIDACIONES) &&
        <ItemsSolPago item={item} openModalInfo={openModalInfo} setOpenModalInfo={setOpenModalInfo} />
      }
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_CON_OP_RECIBOS_Y_RETENCIONES) &&
        <ItemsSolPagoOP item={item} openModalInfo={openModalInfo} setOpenModalInfo={setOpenModalInfo} />
      }
      {(Number(estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.HIV) &&
        <ItemsHiv item={item} openModalInfo={openModalInfo} setOpenModalInfo={setOpenModalInfo} />
      }
    </>
  )
}
